import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import store from "./store/store";
import AppRoutes from "./routes/AppRoutes";
import { HashRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import FirebaseMessaging from "./firebase/FirebaseMessaging";
import WebSocketNotifications from "./services/WebSocketNotifications";
import { getRegisterId } from "./utils/authId";
import { getUserToken } from "./utils/auth";

function App() {
  // useEffect(() => {
  //   const token = getUserToken() || {};
  //   if (token) {
  //     WebSocketOnline.connect(token);
  //     WebSocketOnline.callbacks.onmessage = (data) => {
  //       console.log("Received WebSocket data:", data);
  //     };
  //   }
  //   return () => {
  //     WebSocketOnline.disconnect();
  //   };
  // }, []);

  // const { user } = getUserDetails() || {};
  const token = getUserToken() || {};
  const id = getRegisterId();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 1000 * 60 * 5, // 5 minutes
      },
    },
  });
  return (
    <HashRouter>
      <Provider store={store}>
        <ToastContainer />
        {/* <NotificationListener /> */}
        <QueryClientProvider client={queryClient}>
          {/* {user && <ChatNotifications currentUser={user} />} */}
          {/* <WebSocketNotifications registerId={id} token={token} /> */}
          <AppRoutes />
          <FirebaseMessaging />

          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </HashRouter>
  );
}

export default App;
